var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVisualizationSelectionFunnel = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#81848F"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2 46h46v2H0V0h2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44 5v7H6V5zm-3 10v7H9v-7zm-4 10v7H13v-7zm-4 10v7H17v-7z"
}))));
export default SvgVisualizationSelectionFunnel;